module.exports = __webpack_public_path__ + "img/viggo_crudo.8328fb25.jpg";